// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + "d5b757b0" + ".chunk.css";
};